<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-07-26 10:50:42
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:41:47
 * @FilePath: /chaoyongtuan/src/views/talentCRM/myTalent/components/deleteDialog/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="提示" width="25%" :visible.sync="visible">
		<p>删除达人会同步删除联系人信息，删除后将无法恢复，确认要删除吗？</p>
		<div class="footer-dialog" slot="footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="deleteConfirm">删 除</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { delAnchor } from '@/api/talentCRM';
export default {
	data() {
		return {
			visible: false,
			partner_anchor_id: '',
		};
	},
	methods: {
		show(value) {
			this.partner_anchor_id = value;
			this.visible = true;
		},
		async deleteConfirm() {
			const { partner_anchor_id } = this;
			const { code, data } = await delAnchor({ partner_anchor_id });
			if (code === 0) {
				this.$message.success('删除成功');
				this.visible = false;
				this.$emit('refresh');
			}
		},
	},
};
</script>
<style lang="less" scoped></style>
